import { render, staticRenderFns } from "./email-confirm.vue?vue&type=template&id=568abc59&scoped=true&"
import script from "./email-confirm.vue?vue&type=script&lang=ts&"
export * from "./email-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./email-confirm.vue?vue&type=style&index=0&id=568abc59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568abc59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VFlex,VLayout,VProgressCircular})
